import axiosInstance from "../Common/Axios/axiosInstance";
import API from "../Common/Endpoint/serviceConstrants";

export const callCardMasterGetApi = async (payload) => {
  const { data = [] } = await axiosInstance.get(`${API.card_Master}?enabled=true`);
  return data;
};
